import { render, staticRenderFns } from "./partnerLogo.vue?vue&type=template&id=340b9a32&scoped=true"
import script from "./partnerLogo.vue?vue&type=script&lang=ts"
export * from "./partnerLogo.vue?vue&type=script&lang=ts"
import style0 from "./partnerLogo.vue?vue&type=style&index=0&id=340b9a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b9a32",
  null
  
)

export default component.exports